module.exports = __webpack_public_path__ + "img/outside_m_1.135fc876.png";